<template>
    <div>
      <p>აირჩიეთ გამოკვლევის დასახელება {{patientId}}</p>
        <div class="w3-half">
            <select class="w3-select" v-model="selected">
              <option 
                v-for="value in testDefs"
                v-bind:key="value.test_pack_id"
                v-bind:value="value.test_pack_id"
              >{{value.test_pack_name}}</option>
            </select>
        </div>
            <button class="w3-button" @click="registerTest">Register New Test</button>
    </div>
</template>

<script>
import { mapGetters } from 'vuex';
import { router } from 'vue-router';
export default {
  name: "testPackSelector",
  props: ['patientId'],
  data: function(){
    return {
      selected: null
      ,patientId: this.$attrs.patientId
    }
  },
  props: [],
  computed: {
    ...mapGetters({testDefs:"getTestDefs"})
  },
  methods: {
    registerTest: function(){
      // console.log("register test")
      // console.log(this.slected)
      // console.log("this is:")
      // console.log(this)
      console.log("parient id from prop is")
      // console.log(patientId)
      // let x = this.selected
      // console.log(x);
      this.$router.push({ name: "editTest", params: { patientId: this.patientId, testPackId: this.selected } });
    }
  }
}
</script>

<style>

</style>
